import { UrlMatchResult, UrlSegment } from '@angular/router';

export function matchDotCMSPageRoute(segments: UrlSegment[]): UrlMatchResult {
  const dotCmsRouteFormat = /^\/page\/(.*)$/;
  const url = `/${segments.map(s => s.path).join('/')}`;

  if (/^\/(home)$/.test(url) || /^\/(ema)$/.test(url)) {
    return {
      consumed: [],
    };
  }

  if (dotCmsRouteFormat.test(url)) {
    return {
      consumed: [],
    };
  }

  return;
}
export function dotCmsPageUri(routerURL: string) {
  const dotCmsRouteFormat = /^\/page\/(.*)$/;
  const homepageRouteFormat = /^\/(home)$/;

  if (dotCmsRouteFormat.test(routerURL)) {
    return routerURL.slice(5);
  }
  if (homepageRouteFormat.test(routerURL)) {
    return '/index';
  }
  return null;
}
